import * as z from 'zod';

import { homeDialogSchema } from '@shared/lib/home-drawer-route';

// Kept out of `home.tsx` so `app.router.tsx` can import the schema without
// eagerly pulling in the lazy-loaded `Home` component along with it (same
// split as basic's `home.schema.ts`).
//
// `dialog`: which home drawer is open -- see `@shared/lib/home-drawer-route`.
export const homeSearchSchema = z.object({
	dialog: homeDialogSchema,
});

export type HomeSearch = z.infer<typeof homeSearchSchema>;
